import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  children,
  href = '#pricing',
  className = '',
  onClick
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (onClick) {
      onClick();
    } else if (href.startsWith('#')) {
      e.preventDefault();
      const targetId = href.substring(1);
      const element = document.getElementById(targetId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  const baseClasses = `
    inline-flex items-center justify-center w-full
    px-5 py-3.5
    font-bold text-sm sm:text-base uppercase tracking-wide
    rounded-lg
    bg-brand-petrol text-white
    hover:bg-brand-petrol/90 hover:shadow-xl
    transition-all duration-200
    border-2 border-brand-petrol
    ${className}
  `;
  if (href && !href.startsWith('#')) {
    return <a href={href} className={baseClasses} onClick={handleClick} data-id="element-50" data-mp="199y524gldgyz">
        {children}
      </a>;
  }
  return <button className={baseClasses} onClick={handleClick} data-id="element-51" data-mp="1db070t1w874n">
      {children}
    </button>;
}